import React, { useState, useEffect } from 'react';
import { Layout, Row, Col } from 'antd';
import Typography from '../typography/typography';
import logoFaded from 'assests/images/logo-faded.png';
import './footer-without-auth.less';
import ArrowRight from '../../assests/icons/arrow-right';

import { FooterPackagesList,FooterMessagesList,FooterReportsList,FooterProfileList,FooterSupportList,FooterBlogList } from 'constants/menu.const';
import { NavLink } from 'react-router-dom';
const { Footer: AntdFooter } = Layout;
const { Title, Link, Text } = Typography;

const basicInfoData = [
  { title: 'Müşteri Hizmetleri', text: '532 ya da 0 532 532 0000' },
  { title: 'Ticaret Sicil No', text: '304844' },
  { title: 'Mersis No', text: '6-1248-6542-5749474' },
  { title: 'Denetim Mercii', text: 'Bilgi Teknolojileri ve İletişim Kurumu' }
];

const BasicInfoItem = ({ title, text }) => (
  <div className="basic-info-item">
      <Title level={5}>{title}</Title>
    <Text light>{text}</Text>
  </div>
);

function getWindowDimensions() {
  const { innerHeight: height } = window;
  return {
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const Footer = () => {
  const { height  } = useWindowDimensions();
  const [screenHeight, setScreenHeight] = useState(0);

  useEffect(() => {
    setScreenHeight( document.documentElement.offsetHeight )
  })

  return (
    <div className="footer footer-without-auth">
      <div className='container'>
        { height < screenHeight ? <button className="go-up" onClick={ () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          })
        } }>
          <ArrowRight />
        </button> : false }
      </div>
      <Row justify="center" className="footer-top-line-container">
        <div className="container">
          <Row justify="center" className="footer-top-line">
            {basicInfoData.map((item) => (
              <BasicInfoItem
                key={item.title}
                title={item.title}
                text={item.text}
              />
            ))}
            <div className="basic-info-item">
              <Title level={5}>Blog</Title>
                  {FooterBlogList.items.map((item, index) => (
                    <li key={'blog-'+index}>
                      <Text light><NavLink to={item.link} target={'_blank'}>{item.text}</NavLink></Text>
                    </li>
                  ))}
            </div>
          </Row>
        </div>
      </Row>
      <Row justify="center" className="footer-bottom-line-container">
        <div className="container">
          <Row justify="space-between" className="footer-bottom-line">
            <Col
              xs={{ order: 2, span: 24 }}
              sm={{ order: 2, span: 24 }}
              md={{ order: 2, span: 24 }}
              lg={{ order: 1, span: 14 }}
              xl={{ order: 1, span: 14 }}
              className="footer-bottom-line-left"
            >
              <img src={logoFaded} className="logo" style={{ width: 200 }} />
            </Col>
            <Col
              xs={{ order: 1, span: 24 }}
              sm={{ order: 1, span: 24 }}
              md={{ order: 1, span: 24 }}
              lg={{ order: 2, span: 10 }}
              xl={{ order: 2, span: 10 }}
              className="footer-bottom-line-right"
            >
             <a
                target="_blank"
                className="footer-bottom-line-right-item"
                href="https://www.turkcell.com.tr/tr/gizlilik-ve-guvenlik"
                style={{ textAlign: 'center' }}
              >
                Gizlilik ve Güvenlik
              </a>
              <Text className="footer-bottom-line-right-item">
                Turkcell Mesaj Üssü 2023
              </Text>
            </Col>
          </Row>
        </div>
      </Row>
    </div>
  );
};

export default Footer;